<template>
    <ul>
        <li v-for="item in nav.menu" :key="item.name">
            <IconButton class="tertiary size-l"
                :icon="item.icon"
                :class="{ active: nav.menuItemIsActive(item.name) }"
                @click="nav.open(item.name)"
            />
        </li>
    </ul>
</template>

<script setup>
    import stores from '@/stores';
    import IconButton from '🔗/components/ui/IconButton.vue';

    const nav = stores.nav();
</script>

<style lang="scss" scoped>
ul {
    background: var(--white-80);
    backdrop-filter: blur(8px);
    // border-top: solid 1px var(--primary-20);
    // box-shadow: 0px 4px 6px -4px var(--dark-500);

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-shrink: 0;
    z-index: 1;
    height: var(--nav-height);

    li {
        display: flex;
        flex: 1 1;

        button {
            flex: 1 1;
            padding-bottom: 4px;
            height: 62px !important;

            &.tertiary.active {
                background: transparent;
                backdrop-filter: none;
            }
        }
        // a {
        //     height: 54px;
        //     display: flex;
        //     flex-direction: column;
        //     gap: 8px;
        //     flex: 1 1 100%;
        //     align-items: center;
        //     justify-content: center;
        //     opacity: .6;

        //     svg {
        //         fill: var(--white-500);
        //         width: 18px;
        //         height: 18px;
        //     }
        //     span {
        //         font: var(--font-label);
        //         color: var(--white-500);
        //     }

        //     &.active {
        //         opacity: 1;
        //     }
        // }
    }
}
</style>
